export function DashboardDocsSentToOffice() {
  return (
    <div className='lg:w-full w-11/12 flex flex-col gap-4'>
      <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col bg-[#5186C0] font-mont text-white'>
        <div className='w-full flex flex-col items-center'>
          <div className='w-full flex flex-col items-center gap-4'>
            <p className='font-bold text-xl text-center'>No Additional Step Required at this Time.</p>
          </div>
        </div>
      </div>
      <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col items-center bg-white font-mont gap-4'>
        <p className='font-bold text-2xl text-[#646464]'>What Do I Do Next?</p>
        <div className='w-full flex flex-col items-start gap-4'>
          <p className='font-bold text-xl text-[#646464]'>Your Packet Is On Its Way To Us!</p>
          <p className='text-xl text-[#646464]'>We've received notification that your packet has been shipped.</p>
          <p className='text-xl text-[#646464]'>Once your documents arrive, we'll carefully review them to ensure everything is in order. You can expect to hear from us within 3-5 business days once the review is complete.</p>
          <p className='font-bold text-xl text-[#646464]'>What Happens Next:</p>
          <p className='text-xl text-[#646464]'><span className='font-bold'>SETC Pros Receives Your Packet -</span> We will carefully review all of the documents you've sent.</p>
          <p className='text-xl text-[#646464]'><span className='font-bold'>Review and Confirmation -</span> Our team will review your packet to ensure everything is accurate and complete.</p>
          <p className='text-xl text-[#646464]'><span className='font-bold'>Update of Status -</span> We will update you with the status of your packet and the next steps.</p>
        </div>
      </div>
    </div>
  )
}